
<div class="nsw-p-bottom-sm nsw-p-top-sm">
    <h3>Amenities</h3>        
</div>

<span class="about-site-amenities-text" *ngIf="0 === amenities?.length">Amenity information not available.</span>       

<ng-container *ngFor="let items of amenitiesMatrix; let i = index">
    <div class="nsw-grid" style="margin-left: 0.5rem;">
        <div class="nsw-col row-padding-top-bottom">
            <div class="nsw-grid">
                <ng-container *ngFor="let item of items; let j = index">	
                    <div class="nsw-col-md-6 row-padding-top-bottom">  
                        <app-site-amenity [amenity]="item"></app-site-amenity>                              
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>    



